// extracted by mini-css-extract-plugin
export default {"about_container":"About_about_container__M-95V","about_inner":"About_about_inner__MICYv","about_heading":"About_about_heading__2RMbK","about_details":"About_about_details__8bGCp"};